import React, { useState, useEffect } from 'react';
import useUserStore from './UserStore';

const UserSessionWarning = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const extendSession = useUserStore((state) => state.extendSession);
  const logout = useUserStore((state) => state.logout);

  useEffect(() => {
    const handleSessionWarning = (event) => {
      setShowWarning(true);
      setTimeRemaining(event.detail.timeRemaining);
    };

    const handleSessionExpired = () => {
      setShowWarning(false);
      // Logout is handled automatically by the store
    };

    window.addEventListener('sessionWarning', handleSessionWarning);
    window.addEventListener('sessionExpired', handleSessionExpired);

    return () => {
      window.removeEventListener('sessionWarning', handleSessionWarning);
      window.removeEventListener('sessionExpired', handleSessionExpired);
    };
  }, []);

  // Update countdown timer
  useEffect(() => {
    if (showWarning && timeRemaining > 0) {
      const interval = setInterval(() => {
        setTimeRemaining(prev => {
          if (prev <= 1000) {
            setShowWarning(false);
            return 0;
          }
          return prev - 1000;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [showWarning, timeRemaining]);

  const handleExtendSession = () => {
    extendSession();
    setShowWarning(false);
  };

  const handleLogout = () => {
    logout();
  };

  if (!showWarning) return null;

  const minutes = Math.floor(timeRemaining / 60000);
  const seconds = Math.floor((timeRemaining % 60000) / 1000);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full mx-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Session Expiring Soon
        </h3>
        <p className="text-gray-600 mb-4">
          Your session will expire in {minutes}:{seconds.toString().padStart(2, '0')} due to inactivity.
        </p>
        <div className="flex gap-3">
          <button
            onClick={handleExtendSession}
            className="flex-1 bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
          >
            Continue Session
          </button>
          <button
            onClick={handleLogout}
            className="flex-1 bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserSessionWarning;